import React, { FC } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import productCardStyles from "../../styles/Home/ProductCard";
import { addToCart } from '../../flux/actions/shoppingCart-actions';
import { ProductModel } from "../../models/product-model";

interface ProductDetailsProps {
  product: ProductModel;
}

const HomeProductCard: FC<ProductDetailsProps> = (props) => {
  const classes = productCardStyles();
  const dispatch = useDispatch();
  const { product } = props;

  const addToCartHandler = (id: string) => {
    dispatch(addToCart(id, 1));
  }

  return (
      <Card className={classes.root}>
        <CardActionArea>
          <Link to={`product/${product._id}`}>
            <CardMedia
              component="img"
              alt={product.full_name}
              height="300"
              image={product.image}
              title={product.full_name}
            />
          </Link>
        </CardActionArea>
        <CardContent>
          <Typography variant="h5" component="h2">
            {product.full_name}
          </Typography>
          <p>
            Precio <br /> <span className={classes.price}>${product.cost.toFixed(2)}</span>{" "}
          </p>
          <Typography variant="body2" component="p">
            {product.description}
          </Typography>
        </CardContent>
        <hr />
        <CardActions>
          <Button size="small" color="primary">
            <Link to={`/product/${product._id}`} className={classes.cardButton}>
              Ver
            </Link>
          </Button>
          <Button 
            size="small" 
            color="secondary"
            onClick={() => addToCartHandler(product._id)}
          >
            <span className={classes.cardButton}>Añadir</span>
          </Button>
        </CardActions>
      </Card>
  );
};

export default HomeProductCard;
